'use client';

import React from 'react';

interface PlayWidgetsProps {
  children: React.ReactNode;
}

const PlayWidgets: React.FC<PlayWidgetsProps> = ({ children }) => (
  <div className="flex flex-col gap-4" data-testid="play-widgets">
    {children}
  </div>
);

export default PlayWidgets;
